import React from 'react';
import { useDispatch } from 'react-redux';

import { deleteClient } from '../../../actions';
import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';

// Redesign of newadmin/DeleteClientModal.js — same deleteClient(client.id)
// thunk (which reloads the page on success, as before).
const DeleteClientModal = ({ open, onClose, client }) => {
    const dispatch = useDispatch();

    const formSubmit = (e) => {
        e.preventDefault();
        dispatch(deleteClient(client.id));
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose} title="Delete Client" size="sm">
            <form onSubmit={formSubmit} className="flex flex-col flex-1 min-h-0 overflow-hidden">
                <ModalBody className="flex-1">
                    <p className="text-sm text-[#1F2937]">
                        Are you sure you wish to remove <strong>{client?.name}</strong> from this application?
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={onClose}>
                        Close
                    </Button>
                    <Button variant="danger" type="submit">
                        Remove Client
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default DeleteClientModal;
